<div class="loading-spinner" *ngIf="loading">
    <ion-spinner name="circles"></ion-spinner> {{ 'cargando' | translate | titlecase }}
</div>